import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { DeviceInfo } from "@/interface/deviceInfo";
import { RootState } from "@/redux/reducers";
import { VideoState } from "@/components/VideoPage/redux/types";

const selectArticle = (state: RootState): VideoState => state?.video;

export default createDraftSafeSelector(selectArticle, (video: VideoState): DeviceInfo => video.ua);
